"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const react_1 = __importStar(require("react"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const auto_focus_hook_1 = require("../../utils/auto-focus-hook");
const empty_component_1 = require("../../utils/empty-component");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const highlighted_text_area_1 = require("./highlighted-text-area");
const text_area_styles_1 = require("./text-area-styles");
exports.TextArea = (0, react_1.forwardRef)(function TextArea({ form, onChange, disabled, value, onBlur, onFocus, startAdornment, endAdornment, onChangeEvent, error = false, minRows = 3, maxRows = 12, autoFocus, fontSize = 14, inputBackgroundColor, name, showHighlightedComponent = false, HighlightedContent = empty_component_1.EmptyComponent, }, ref) {
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    // prepare value for MUI component
    value = value !== null && value !== void 0 ? value : '';
    const handleChange = (0, event_callback_hook_1.useEventCallback)((e) => {
        if (onChangeEvent !== undefined) {
            onChangeEvent(e);
        }
        if (onChange !== undefined) {
            const value = e.target.value;
            onChange(value !== '' ? value : null);
        }
    });
    const { autoFocusRef } = (0, auto_focus_hook_1.useAutoFocus)(autoFocus, disabled);
    const classes = (0, text_area_styles_1.useStyles)();
    startAdornment = startAdornment && (react_1.default.createElement(InputAdornment_1.default, { position: "start" }, startAdornment));
    endAdornment = endAdornment && (react_1.default.createElement(InputAdornment_1.default, { position: "end" }, endAdornment));
    return showHighlightedComponent ? (react_1.default.createElement(highlighted_text_area_1.HighlightedTextArea, { fontSize: fontSize, minRows: minRows, maxRows: maxRows, highlightedContent: react_1.default.createElement(HighlightedContent, null) })) : (react_1.default.createElement(TextField_1.default, { InputProps: {
            classes,
            startAdornment,
            endAdornment,
            style: {
                fontSize,
                backgroundColor: inputBackgroundColor,
            },
        }, inputProps: {
            form,
            spellCheck: 'true',
        }, inputRef: autoFocusRef, ref: ref, name: name, disabled: disabled, value: value, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, error: error, fullWidth: true, lang: "cs", multiline: true, rows: minRows, rowsMax: maxRows }));
});
//# sourceMappingURL=text-area.js.map